import { render } from "./AgencyTab.vue?vue&type=template&id=77f9682c"
import script from "./AgencyTab.vue?vue&type=script&lang=js"
export * from "./AgencyTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__